module.exports = __webpack_public_path__ + "static/media/childrens_museum_mural_baby_dino_rendering_classic_cartoon_style.cb44a269.webp";